import * as IconSolid from '@heroicons/react/24/solid'
import * as IconOutline from '@heroicons/react/24/outline'
import * as IconPhospor from '@phosphor-icons/react'

export default { IconSolid, IconOutline, IconPhospor }